/**
 * In-app (operator hub) event names from legacy mobile `buxus-frontend` (`src/util/analytics.constants.ts`).
 * Used with `page_viewed` + GA4 `screen_view` mapping — keep strings stable for dashboards.
 */
export const AppEventTypes = {
  ACCORDION_COLLAPSED: "accordion_collapsed",
  ACCORDION_EXPANDED: "accordion_expanded",
  ALERT_PREVIEWED: "alert_previewed",
  ALERT_SENT: "alert_sent",
  APP_STARTED: "app_started",
  AUTH_MODE_TOGGLED: "auth_mode_toggled",
  BUTTON_PRESSED: "button_pressed",
  EMAIL_PRESSED: "email_pressed",
  FILE_OPEN_DISMISSED: "file_open_dismissed",
  FILE_OPEN_FAILED: "file_open_failed",
  FILE_OPEN_PRESSED: "file_open_pressed",
  FILE_OPEN_STARTED: "file_open_started",
  FILE_OPEN_SUCCEEDED: "file_open_succeeded",
  FILE_VIEWED: "file_viewed",
  FORM_SUBMITTED: "form_submitted",
  FORM_VALIDATION_FAILED: "form_validation_failed",
  LINK_PRESSED: "link_pressed",
  MAP_LOAD_FAILED: "map_load_failed",
  MAP_POPUP_DISPLAYED: "map_popup_displayed",
  MAP_TAPPED: "map_tapped",
  NAVIGATION_REDIRECTED: "navigation_redirected",
  /** Catch-all when connectivity / request failure has no matching action outcome event. */
  NETWORK_REQUEST_FAILED: "network_request_failed",
  /**
   * Operator download succeeded for core JSON, but one or more manifest file
   * cache steps failed (best-effort). One event per download, not per file.
   */
  OPERATOR_MANIFEST_FILE_CACHE_FAILED: "operator_manifest_file_cache_failed",
  LOGIN_METHOD_DISCOVER_FAILED: "login_method_discover_failed",
  LOGIN_METHOD_DISCOVERED: "login_method_discovered",
  MENU_ITEM_SELECTED: "menu_item_selected",
  PAGE_VIEWED: "page_viewed",
  PHONE_PRESSED: "phone_pressed",
  TOKEN_ID_DECODE_FAILED: "token_id_decode_failed",
  TOKEN_ID_DECODED: "token_id_decoded",
  URL_PRESSED: "url_pressed",
  USER_DATA_SAVED: "user_data_saved",
  USER_LOGGED_IN: "user_logged_in",
  USER_LOGGED_OUT: "user_logged_out",
  USER_LOGIN_ATTEMPTED: "user_login_attempted",
  USER_LOGIN_FAILED: "user_login_failed",
  USER_LOGIN_FLOW_FAILED: "user_login_flow_failed",
} as const

export type AppEventName = (typeof AppEventTypes)[keyof typeof AppEventTypes]
